import ProductStep from './ProductStep';

const config = {
  name: 'product',
  component: ProductStep,
};

export default config;
